export const environment = {
    production: true,
    // api_base_url: 'https://t55n1b6s46.execute-api.eu-west-2.amazonaws.com/qa/',
    api_base_url: 'https://h336pu7ih2.execute-api.eu-west-2.amazonaws.com/qa/',
    Audit: 'ccc8e0d5-028b-4027-9e64-cdc3f9085e5f',
    Branch: 'e4375041-47b9-4d97-abe0-9ec2b7fd55da',
    Distribution: 'da2b7b69-a549-4645-9db8-c0bf5de6237f',
    Period: '9639a49a-505d-4555-afdb-ddcc337138a3',
    Publisher: 'ac85a661-7ca3-4782-937a-367be54e487a',
    LeagueTable: 'f857b399-e91e-4ce5-96c9-dc17a263b5b6',
    Region: '6e9521e6-860a-4c28-8222-688d72042c09',
    Trend: 'c0e8b1ac-9f8a-4b40-8def-e458bdad2dfc',
    app_version: '1.0.5'
};
